import { Modal } from "react-bootstrap";

const ShortCutKeyModal = ({ open, onClose }) => {
  return (
    <Modal
      show={open}
      dialogClassName="custom-modal"
      onHide={() => onClose(false)}
    >
      <Modal.Header closeButton>
        <div>
          <h3 style={{ color: "#EF4667" }}>ShortCut Keys</h3>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="shortCutRow">
          <div className="shortCutCol">
            <div>
              <h4 className="shortkeyHeading">DashBoard</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + 1 - Dashboard
              </h6>
              <hr />
              <h4 className="shortkeyHeading">Billing</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + 2 - Billing
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + S - Search and
                Add Item
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + K - Scan Product
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + B - Generate Bill
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + P - Payment Mode
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + I - Add New Item
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + H - Hold Bill
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + C - Enter
                Customer details
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + D - Coupon
                Discount
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + A - Delivery
                Address
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + N - Notes
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + T - Advance
                Settings
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + B - Bill Settings
              </h6>
            </div>
            <hr />
          </div>
          <div className="shortCutCol">
            <h4 className="shortkeyHeading">Shop Items</h4>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Ctrl</span> + 3 - Shop Items
            </h6>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Alt</span> + N - Add
              Item/product
            </h6>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Alt</span> + U - Add Excel
              upload for product
            </h6>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Alt</span> + T - Tax Master
            </h6>
            <hr />
            <h4 className="shortkeyHeading">Reports</h4>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Ctrl</span> + 4 - Reports
            </h6>
            <hr />
            <h4 className="shortkeyHeading">Loyalty Points</h4>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Ctrl</span> + 5 - Loyalty Points
            </h6>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Alt</span> + A - Points History,
              Add and Redeem Points
            </h6>
            <hr />
          </div>
          <div className="shortCutCol">
            <h4 className="shortkeyHeading">Customer Management</h4>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Ctrl</span> + 6 - Customer
              Management
            </h6>
            <hr />
            <h4 className="shortkeyHeading">Vendor Management</h4>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Ctrl</span> + 7 - Vendor
              Management
            </h6>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Alt</span> + A - Add Vender
            </h6>

            <hr />
            <h4 className="shortkeyHeading">Employee Access</h4>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Ctrl</span> + 8 - Employee
              Access
            </h6>
            <hr />
            <h4 className="shortkeyHeading">Settings</h4>
            <h6 className="shortkeyStyle">
              <span className="specialKeyStyle">Ctrl</span> + 9 - Settings
            </h6>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShortCutKeyModal;
